import {
  StyledCard,
  StyledCardContent,
  StyledTableBodyRow,
} from "components/CustomCard";
import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import "./TableBody.scss";
import { RowProjectTable } from "views/ProjectGroupPage/RightPart/AllProjectTable/constants/Columns";
import Scrollbars from "components/Scrollbars";
import { filter, groupBy, forEach, get, reverse, size, sortBy } from "lodash";
import { useLocation, useHistory } from "react-router";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Tab,
  Button,
} from "@mui/material";
import styled from "styled-components";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";
import CustomSeparator from "./CustomSeparator";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { apiService } from "constants/axiosInstance";
import ProjectGroupGrid from "./PropjectGroupGrid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { mdiFilter } from "@mdi/js";
import Icon from "@mdi/react";
import {
  CREATE_PROJECT_GROUP,
  CustomEventDispose,
  CustomEventListener,
  EDIT_PROJECT_GROUP,
  LIST_PROJECT_GROUP,
} from "constants/events";
import { useTranslation } from "react-i18next";
import { EDIT_COLOR_PROJECT_GROUP_REDUCER } from "../../../constants/events";
import ProjectTableDeny from "views/ProjectGroupPage/RightPart/ProjectTableDeny";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import { useFilters } from "components/CustomPopover";

function renderTrackVertical({ style, ...props }) {
  const thumbStyle = {
    position: "absolute",
    width: "6px",
    transition: "opacity 200ms ease 0s",
    opacity: 0,
    right: "0",
    bottom: "2px",
    top: "2px",
    borderRadius: "3px",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
}
function renderThumbHorizontal({ style, ...props }) {
  const thumbStyle = {
    display: "none",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
}

const Container = ({ className = "", ...rest }) => (
  <Scrollbars
    className={`view_projects___container ${className}`}
    renderTrackVertical={renderTrackVertical}
    renderThumbHorizontal={renderThumbHorizontal}
    {...rest}
  />
);

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const StyledTableBodyRowGroup = ({ className = "", children, ...rest }) => (
  <AccordionSummary
    className={`view_users_comp_CustomTable_TableBodyGroup___row ${className}`}
    {...rest}
  >
    {children}
  </AccordionSummary>
);

const StyledButton = styled(Button)`
  & svg.filter {
    margin-left: 12px;
    color: rgb(66, 72, 94) !important;
    width: 1rem !important;
    height: 1rem !important;
    padding: 6px;
    border-radius: 50%;
  }
  & svg.filter:hover {
    color: rgb(66, 72, 94) !important;
    background: #0000000a;
  }
  &:hover {
    background: none;
  }
`;

const CustomButton = ({ className = "", ...rest }) => (
  <StyledButton
    className={`view_users_comp_CustomTable_TableBodyGroup___button ${className}`}
    size="large"
    {...rest}
  />
);

const StyledTableBodyCell = ({ className = "", ...rest }) => (
  <AccordionDetails
    className={`${className}`}
    {...rest}
    sx={{
      backgroundColor: "inherit",
      padding: "0px",
      display: "flex",
      flexDirection: "column",
      alignItems: "self-start",
    }}
  />
);

const Item = ({
  group,
  _handleDragEnd,
  onEdit,
  onOpenEditModal,
  openEditLabel,
}) => {
  const [open, setOpen] = React.useState(true);

  return (
    <Accordion
      expanded={open}
      sx={{ boxShadow: "none", backgroundColor: "inherit" }}
    >
      <StyledTableBodyRowGroup
        style={{
          height: "40px",
          minHeight: "40px",
        }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <CustomButton fullWidth>
          {open ? (
            <ArrowDropDownRoundedIcon fontSize="large" />
          ) : (
            <ArrowRightRoundedIcon fontSize="large" />
          )}
          <div className="cus_item_css">{group?.group_name ?? ""}</div>
        </CustomButton>
      </StyledTableBodyRowGroup>
      <StyledTableBodyCell>
        {!!group.projects?.length &&
          group.projects.map((item, index) => {
            return (
              <div className="comp_cus_table_view_project_group">
                <StyledTableBodyRow>
                  <StyledCard className={`card_cus_row`}>
                    <StyledCardContent className="cus_table_row_view_project_group">
                      <RowProjectTable
                        onEdit={onEdit}
                        onOpenEditModal={onOpenEditModal}
                        openEditLabel={openEditLabel}
                        row={item}
                        isShared={true}
                      />
                    </StyledCardContent>
                  </StyledCard>
                </StyledTableBodyRow>
              </div>
            );
          })}
      </StyledTableBodyCell>
    </Accordion>
  );
};

const WPTable = ({
  expand,
  data = [],
  onDragEnd = () => {},
  refFilterCustom = null,
  onEdit = () => {},
  onOpenEditModal = () => {},
  openEditLabel = () => {},
  handleSortProjectGroup,
  setCurrentGroup,
  setCurrentGroupAction,
  doReloadList,
  setActiveLoading,
  activeLoading,
  handleOpenModal,
  groupID,
  currentGroup,
  getCurrentGroup,
  localOption: { filterType, labelType, timeType },
  searchValue,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const filters = useFilters();
  const [dataRows, setDataRows] = React.useState([]);
  const [dataShared, setDataShared] = React.useState([]);
  const refFilter = refFilterCustom;
  const query = useQuery();
  const isShared = query.get("is-shared");
  console.log(dataRows, "dataRows drag");

  const returnProjectsFiltered = (projects) => {
    let _projects = [...projects];
    // _projects = sortBy(_projects, (o) => get(o, sortType.col));
    // _projects = sortType.dir === -1 ? reverse(_projects) : _projects;
    if (filters?.[filterType]?.option) {
      _projects = filter(_projects, filters[filterType].option);
    }
    if (labelType && labelType !== -1) {
      _projects = filter(_projects, { project_label: { id: labelType } });
    }
    // if (labelType && labelType === -1) {
    //   _projects = filter(_projects, { project_label: {} });
    //   console.log(_projects, "prokect sort xx 4");
    // }
    if (searchValue.trim().length) {
      _projects = _projects.filter((obj) => {
        return (
          JSON.stringify(obj.name)
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          JSON.stringify(obj?.project_group?.name)
            ?.toLowerCase()
            .includes(searchValue.toLowerCase())
        );
      });
    }
    return _projects;
  };

  async function doListProjectShared() {
    try {
      const config = {
        url: "/project/list-share-to-me",
        method: "get",
      };
      const result = await apiService(config);
      console.log(result, "data sare");
      let tmpShared = result?.data?.projects;
      tmpShared = tmpShared.map((item) => {
        let tmp = returnProjectsFiltered(item?.projects ?? []);
        return {
          ...item,
          projects: tmp,
        };
      });
      tmpShared = tmpShared.filter((item) => (item?.projects?.length ?? 0) > 0);
      setDataShared(tmpShared);
    } catch (error) {
      throw error;
    }
  }

  React.useEffect(() => {
    if (isShared) {
      doListProjectShared();
    } else {
      setDataRows(data);
      console.log(data, "row?.project_label data");
    }
  }, [data, isShared]);
  const projectGroups = [];
  forEach(groupBy(dataRows, "project_group_id"), function (value, key) {
    projectGroups.push({ id: key, projects: value });
  });
  console.log(projectGroups);

  const _handleDragEnd = (result) => {
    if (!result) return;
    const resultSort = reorder(
      dataRows,
      result.source.index,
      result.destination.index
    );
    setDataRows(resultSort);
    onDragEnd(resultSort);
  };

  const [value, setValue] = React.useState("1");
  const [openGroup, setOpenGroup] = React.useState(true);
  const [openTable, setOpenTable] = React.useState(true);
  const [firstRender, setFirstRender] = React.useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [groups, setGroups] = React.useState([]);

  async function doListProjectGroup({ timeStart, timeEnd, projectGroupId }) {
    try {
      const config = {
        url: "/project-group/list",
        method: "get",
        params: {
          start_time: timeStart,
          end_time: timeEnd,
          parent_group: projectGroupId,
        },
      };
      const result = await apiService(config).then((data) => {
        setGroups(data?.data?.project_groups);
        console.log(data?.data?.project_groups, "data?.data?.project_groups");
        return data;
      });

      return result?.data;
    } catch (error) {
      throw error;
    }
  }
  console.log(groups, "groups groups");

  React.useEffect(() => {
    CustomEventListener(EDIT_COLOR_PROJECT_GROUP_REDUCER, ({ detail }) => {
      console.log("EDIT_COLOR_PROJECT_GROUP_REDUCER render");
      doListProjectGroup({ projectGroupId: groupID });
    });
    return () => {
      CustomEventDispose(EDIT_COLOR_PROJECT_GROUP_REDUCER, () => {});
    };
  }, []);
  console.log(firstRender, "firstRender");
  React.useEffect(() => {
    setFirstRender(false);
    const handleChageGroupEventFunction = () => {
      if (!!groupID) {
        console.log("CREATE_PROJECT_GROUP.SUCCESS render");
        doListProjectGroup({ projectGroupId: groupID });
      }
    };
    handleChageGroupEventFunction();
    CustomEventListener(
      CREATE_PROJECT_GROUP.SUCCESS,
      handleChageGroupEventFunction
    );

    CustomEventListener(
      EDIT_PROJECT_GROUP.SUCCESS,
      handleChageGroupEventFunction
    );

    CustomEventListener(
      LIST_PROJECT_GROUP.SUCCESS,
      handleChageGroupEventFunction
    );

    return () => {
      CustomEventDispose(
        CREATE_PROJECT_GROUP.SUCCESS,
        handleChageGroupEventFunction
      );
      CustomEventDispose(
        EDIT_PROJECT_GROUP.SUCCESS,
        handleChageGroupEventFunction
      );
      CustomEventDispose(
        LIST_PROJECT_GROUP.SUCCESS,
        handleChageGroupEventFunction
      );
    };
  }, [groupID]);

  console.log(dataRows, "dataRows");

  return (
    <Box
      className="cus_container_projects_groupID scrollbar-custom"
      sx={{
        padding: "26px 35px 14px",
        background: "#fff",
        margin: "35px",
        borderRadius: "20px",
      }}
    >
      {!isShared && <CustomSeparator currentGroup={currentGroup} />}
      <Box sx={{ width: "100%", typography: "body1" }}>
        {isShared ? (
          <>
            <StyledTableBodyCell className="project-group">
              {(labelType !== -1 || filterType !== 0 || timeType !== 5) && (
                <Box
                  onClick={() => refFilter.current._toggle()}
                  sx={{
                    marginBottom: "6px",
                    color: "#607d8b",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    "& .filter": {
                      width: "1rem !important",
                      height: "1rem !important",
                      padding: "15px 10px 15px 0px",
                    },
                    "& span": {
                      color: "#007DF3",
                      marginLeft: "10px",
                      fontWeight: 500,
                      cursor: "pointer",
                      padding: "5px 10px",
                      borderRadius: "6px",
                      background: "#00000008",
                    },
                  }}
                >
                  <Icon className="filter" path={mdiFilter} size={1} />{" "}
                  {t("GROUP_PROJECT_PAGE.FILTERING")}{" "}
                  <span>{t("GROUP_PROJECT_PAGE.CONFIG_FILTER")}</span>
                </Box>
              )}
            </StyledTableBodyCell>
            <Container autoHide autoHideTimeout={500}>
              <div style={{ paddingBottom: "12px" }}>
                {dataShared.map((group) => {
                  return (
                    <Item
                      group={group}
                      _handleDragEnd={_handleDragEnd}
                      onEdit={onEdit}
                      onOpenEditModal={onOpenEditModal}
                      openEditLabel={openEditLabel}
                    />
                  );
                })}
                {dataShared.length === 0 && (
                  <ProjectTableDeny
                    icon={<Diversity3Icon sx={{ color: "#9A9A9A" }} />}
                    title={t("PROJECT_TABLE_DENY.EMPTY_PROJECT.TITLE")}
                    description={t("PROJECT_TABLE_DENY.EMPTY_PROJECT.DES")}
                  />
                )}
              </div>
            </Container>
          </>
        ) : (
          <Container>
            <Accordion
              expanded={openGroup}
              sx={{ boxShadow: "none", backgroundColor: "inherit" }}
            >
              <StyledTableBodyRowGroup
                style={{
                  height: "40px",
                  minHeight: "40px",
                  transform: "translateX(-8px)",
                }}
              >
                <CustomButton fullWidth>
                  {openGroup ? (
                    <ArrowDropDownRoundedIcon
                      onClick={() => {
                        setOpenGroup(!openGroup);
                      }}
                      fontSize="large"
                    />
                  ) : (
                    <ArrowRightRoundedIcon
                      onClick={() => {
                        setOpenGroup(!openGroup);
                      }}
                      fontSize="large"
                    />
                  )}
                  <div
                    className="cus_item_css"
                    onClick={() => {
                      setOpenGroup(!openGroup);
                    }}
                  >
                    {t("GROUP_PROJECT_PAGE.GROUP")}
                  </div>
                  <AddOutlinedIcon
                    style={{
                      marginLeft: "12px",
                      color: "#42485E",
                      padding: 3,
                      borderRadius: "50%",
                    }}
                    sx={{
                      "&:hover": {
                        background: "#EAEDEF",
                      },
                    }}
                    onClick={(evt) => {
                      evt.stopPropagation();
                      handleOpenModal("UPDATE");
                    }}
                  />
                </CustomButton>
              </StyledTableBodyRowGroup>
              <StyledTableBodyCell>
                <ProjectGroupGrid
                  expand={expand}
                  projectGroups={groups}
                  onEdit={onEdit}
                  handleDragEnd={_handleDragEnd}
                  handleSortProjectGroup={handleSortProjectGroup}
                  setCurrentGroup={setCurrentGroup}
                  setCurrentGroupAction={setCurrentGroupAction}
                  doReloadList={doReloadList}
                  setActiveLoading={setActiveLoading}
                  activeLoading={activeLoading}
                  onOpenCreateModal={(evt) => handleOpenModal("UPDATE")}
                />
              </StyledTableBodyCell>
            </Accordion>
            <Accordion
              expanded={openTable}
              sx={{ boxShadow: "none", backgroundColor: "inherit" }}
            >
              <StyledTableBodyRowGroup
                style={{
                  height: "40px",
                  minHeight: "40px",
                  transform: "translateX(-8px)",
                }}
              >
                <CustomButton fullWidth>
                  {openTable ? (
                    <ArrowDropDownRoundedIcon
                      onClick={() => {
                        setOpenTable(!openTable);
                      }}
                      fontSize="large"
                    />
                  ) : (
                    <ArrowRightRoundedIcon
                      onClick={() => {
                        setOpenTable(!openTable);
                      }}
                      fontSize="large"
                    />
                  )}
                  <div
                    className="cus_item_css"
                    onClick={() => {
                      setOpenTable(!openTable);
                    }}
                  >
                    {t("GROUP_PROJECT_PAGE.PROJECT")}
                  </div>
                  <AddOutlinedIcon
                    sx={{
                      "&:hover": {
                        background: "#EAEDEF",
                      },
                    }}
                    style={{
                      marginLeft: "12px",
                      color: "#42485E",
                      padding: 3,
                      borderRadius: "50%",
                    }}
                    onClick={(evt) => {
                      evt.stopPropagation();
                      // handleOpenModal("CREATE");
                      history.push({
                        pathname: "/projects/add-new",
                        state: {
                          groupID,
                          groupName: currentGroup?.name,
                        },
                      });
                    }}
                  />
                  {/* <FilterAltIcon
                    sx={{
                      marginLeft: 12,
                      color: "rbg(66, 72, 94)",
                      width: "1rem",
                      height: "1rem",
                      padding: "6px",
                      borderRadius: "50%"
                    }}
                  /> */}
                  <Icon
                    className="filter"
                    path={mdiFilter}
                    size={1}
                    onClick={(evt) => {
                      evt.stopPropagation();
                      refFilter.current._toggle();
                    }}
                  />
                </CustomButton>
              </StyledTableBodyRowGroup>
              <StyledTableBodyCell className="project-group">
                {(labelType !== -1 || filterType !== 0 || timeType !== 5) && (
                  <Box
                    onClick={() => refFilter.current._toggle()}
                    sx={{
                      marginBottom: "6px",
                      color: "#607d8b",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      "& .filter": {
                        width: "1rem !important",
                        height: "1rem !important",
                        padding: "15px 10px 15px 0px",
                      },
                      "& span": {
                        color: "#007DF3",
                        marginLeft: "10px",
                        fontWeight: 500,
                        cursor: "pointer",
                        padding: "5px 10px",
                        borderRadius: "6px",
                        background: "#00000008",
                      },
                    }}
                  >
                    <Icon className="filter" path={mdiFilter} size={1} />{" "}
                    {t("GROUP_PROJECT_PAGE.FILTERING")}{" "}
                    <span>{t("GROUP_PROJECT_PAGE.CONFIG_FILTER")}</span>
                  </Box>
                )}
                {!!dataRows?.length && (
                  <div style={{ paddingBottom: "12px", width: "100%" }}>
                    <DragDropContext onDragEnd={_handleDragEnd}>
                      <Droppable droppableId="droppable-table">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {dataRows.map((item, index) => {
                              return (
                                <Draggable
                                  draggableId={item.id}
                                  index={index}
                                  key={item.id}
                                >
                                  {(provided) => (
                                    <div
                                      className="comp_cus_table_view_project_group"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <StyledTableBodyRow>
                                        <StyledCard className={`card_cus_row`}>
                                          <StyledCardContent className="cus_table_row_view_project_group">
                                            <RowProjectTable
                                              onEdit={onEdit}
                                              onOpenEditModal={onOpenEditModal}
                                              openEditLabel={openEditLabel}
                                              row={item}
                                              dataRows={dataRows}
                                              expand={expand}
                                            />
                                          </StyledCardContent>
                                        </StyledCard>
                                      </StyledTableBodyRow>
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                )}
                {dataRows.length === 0 && (
                  <div className="no-project-group">
                    <p>{t("DMH.VIEW.PGP.RIGHT.ALL.NO_TABLE")}</p>
                    <p
                      onClick={() => {
                        history.push({
                          pathname: "/projects/add-new",
                          state: {
                            groupID,
                            groupName: currentGroup?.name,
                          },
                        });
                      }}
                    >
                      + {t("DMH.VIEW.PGP.RIGHT.ALL.ADD_TABLE")}
                    </p>
                  </div>
                )}
                {dataRows.length === 0 && (
                  <div className="no-project-group">
                    <p>{t("DMH.VIEW.PGP.RIGHT.ALL.NO_TABLE_TEMPLATE")}</p>
                    <p
                      onClick={() => {
                        history.push({
                          pathname: "/projects/template",
                        });
                      }}
                    >
                      {t("DMH.VIEW.PGP.RIGHT.ALL.NO_TABLE_TEMPLATE_HERE")}
                    </p>
                  </div>
                )}
              </StyledTableBodyCell>
            </Accordion>
          </Container>
        )}
      </Box>
    </Box>
  );
};

export const scrollbarWidth = () => {
  // thanks too https://davidwalsh.name/detect-scrollbar-width
  const scrollDiv = document.createElement("div");
  scrollDiv.setAttribute(
    "style",
    "width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;"
  );
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

export const scrollbarHeight = () => {
  // thanks too https://davidwalsh.name/detect-scrollbar-width
  const scrollDiv = document.createElement("div");
  scrollDiv.setAttribute(
    "style",
    "width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;"
  );
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetHeight - scrollDiv.clientHeight;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

export default WPTable;
